// import {
//   Button,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   CircularProgress,
// } from '@mui/material';
// import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
// import React, { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import HOST_URL from '../../../utils/Url';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { useTranslation } from 'react-i18next';
// import { toast } from 'react-toastify';
// import ToastApp from '../../../ToastApp';

// type Props = {};

// const DepartmentAdd = (props: Props) => {
//   let navigate = useNavigate();
//   const { t } = useTranslation();
//   const back = useNavigate();

//   const requiredFields = ['name'];
//   const [toaster, setToaster] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   // Enhanced validation schema with comprehensive input validation
//   const validationSchema = Yup.object({
//     name: Yup.string()
//       .test(
//         'required',
//         t('text.reqdept_name'),
//         function (value: any) {
//           return value && value.trim() !== '';
//         }
//       )
//       .max(50, t('text.deptNameMaxLength'))
//       .matches(/^[a-zA-Z0-9\s\-&.,()]+$/, t('text.invalidDeptName')) // Allow letters, numbers, spaces, hyphens, and common punctuation
//       .test(
//         'no-special-chars-start-end',
//         t('text.noSpecialCharsStartEnd'),
//         function (value: any) {
//           if (!value) return true;
//           // Check if starts or ends with special characters (excluding spaces)
//           return !/^[^a-zA-Z0-9\s]|[^a-zA-Z0-9\s]$/.test(value);
//         }
//       )
//       .test(
//         'no-multiple-special-chars',
//         t('text.noMultipleSpecialChars'),
//         function (value: any) {
//           if (!value) return true;
//           // Prevent multiple consecutive special characters
//           return !/[\-\s&.,()]{2,}/.test(value);
//         }
//       ),
    
 
//   });

//   // Function to sanitize input by removing unwanted characters
//   const sanitizeInput = (value: string, fieldName: string) => {
//     if (!value) return value;
    
//     let sanitized = value;
    
//     switch(fieldName) {
//       case 'name':
//         // Allow only letters, numbers, spaces, hyphens, and common punctuation
//         sanitized = value.replace(/[^a-zA-Z0-9\s\-&.,()]/g, '');
//         // Remove multiple consecutive special characters
//         sanitized = sanitized.replace(/([\-\s&.,()]){2,}/g, '$1');
//         // Trim special characters from start and end
//         sanitized = sanitized.replace(/^[^a-zA-Z0-9\s]+|[^a-zA-Z0-9\s]+$/g, '');
//         break;
     
//       default:
//         // Default sanitization for other fields
//         sanitized = value.replace(/[<>{}[\]\\]/g, '');
//     }
    
//     return sanitized;
//   };

//   // Custom onChange handler to sanitize input in real-time
//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value } = e.target;
//     const sanitizedValue = sanitizeInput(value, name);
    
//     // Only update if the value changed after sanitization
//     if (value !== sanitizedValue) {
//       formik.setFieldValue(name, sanitizedValue);
//     } else {
//       formik.handleChange(e);
//     }
//   };

//   const formik = useFormik({
//     initialValues: {
//       id: -1,
//       name: "",
//     nodeID: -1,

//      titleID: 0

//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       // Additional server-side validation before submission
//       const sanitizedValues = {
//         ...values,
//         name: sanitizeInput(values.name, 'name'),
     
//       };
      
//       // Clear any existing timeout
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
      
//       // If already submitting, show message and return
//       if (isSubmitting) {
//         toast.info(t("text.requestInProgress"));
//         return;
//       }
      
//       setIsSubmitting(true);
      
//       try {
//         const response = await axios.post(
//           HOST_URL.HOST_URL + `NewNodeMaster/AddUpdateNewNodeMaster`,
//           sanitizedValues
//         );
        
//         if (response.data.isSuccess) {
//           setToaster(false);
//           toast.success(response.data.mesg);
//           navigate('/master/DepartmentMaster');
//         } else {
//           setToaster(true);
//           toast.error(response.data.mesg);
//         }
//       } catch (error: any) {
//         if (error.response && error.response.status === 429) {
//           toast.error(t("text.tooManyRequests"));
//         } else {
//           toast.error(t("text.somethingWentWrong"));
//         }
//         setToaster(true);
//       } finally {
//         // Set a timeout to reset isSubmitting after 2 seconds
//         submitTimeoutRef.current = setTimeout(() => {
//           setIsSubmitting(false);
//         }, 2000);
//       }
//     }
//   });

//   // Clean up timeout on component unmount
//   useEffect(() => {
//     return () => {
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           border: ".5px solid #FF7722",
//           marginTop: "3vh"
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.createdeptmaster")}
//           </Typography>

//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="button"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//                 disabled={isSubmitting}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             {toaster === false ? "" : <ToastApp />}
//             <Grid item xs={12} container spacing={2}>
//               <Grid item lg={6} xs={12}>
//                 <TextField
//                   id="name"
//                   name="name"
//                   label={
//                     <span>
//                       {t("text.enterdeptName")}{" "}
//                       {requiredFields.includes('name') && (
//                         <span style={{ color: formik.values.name ? 'green' : 'red' }}>*</span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.name}
//                   placeholder={t("text.enterdeptName")}
//                   size="small"
//                   fullWidth
//                   style={{
//                     backgroundColor: 'white',
//                     borderColor: formik.touched.name && formik.errors.name ? 'red' : 'initial',
//                   }}
//                   onChange={handleInputChange}
//                   onBlur={formik.handleBlur}
//                   disabled={isSubmitting}
//                   inputProps={{ 
//                     maxLength: 50,
//                     pattern: "[a-zA-Z0-9\\s\\-&.,()]*"
//                   }}
//                   error={formik.touched.name && Boolean(formik.errors.name)}
//                 />
//                 {formik.touched.name && formik.errors.name ? (
//                   <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.name)}</div>
//                 ) : null}
//               </Grid>
// <Grid item lg={6} xs={12}>
//   </Grid>

//               <Grid item lg={6} sm={6} xs={12}>
//                 <Grid>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                       marginTop: "10px",
//                     }}
//                     disabled={isSubmitting || !formik.isValid}
//                     startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
//                   >
//                     {isSubmitting ? t("text.submitting") : t("text.save")}
//                   </Button>
//                 </Grid>
//               </Grid>
//               <Grid item lg={6} sm={6} xs={12}>
//                 <Button
//                   type="reset"
//                   fullWidth
//                   style={{
//                     backgroundColor: "#F43F5E",
//                     color: "white",
//                     marginTop: "10px",
//                   }}
//                   onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
//                     formik.resetForm();
//                   }}
//                   disabled={isSubmitting}
//                 >
//                   {t("text.reset")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default DepartmentAdd;


import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  CircularProgress,
} from '@mui/material';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HOST_URL from '../../../utils/Url';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ToastApp from '../../../ToastApp';

type Props = {};

const DepartmentAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const back = useNavigate();

  const requiredFields = ['name'];
  const [toaster, setToaster] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Enhanced validation schema with comprehensive input validation
  const validationSchema = Yup.object({
    name: Yup.string()
      .test(
        'required',
        t('text.reqdept_name'),
        function (value: any) {
          return value && value.trim() !== '';
        }
      )
      .max(50, t('text.deptNameMaxLength'))
      .matches(/^[a-zA-Z0-9\s\-&.,()]+$/, t('text.invalidDeptName')) // Allow letters, numbers, spaces, hyphens, and common punctuation
      .test(
        'no-special-chars-start-end',
        t('text.noSpecialCharsStartEnd'),
        function (value: any) {
          if (!value) return true;
          // Check if starts or ends with special characters (excluding spaces)
          return !/^[^a-zA-Z0-9\s]|[^a-zA-Z0-9\s]$/.test(value);
        }
      )
      .test(
        'no-multiple-special-chars',
        t('text.noMultipleSpecialChars'),
        function (value: any) {
          if (!value) return true;
          // Prevent multiple consecutive special characters
          return !/[\-\s&.,()]{2,}/.test(value);
        }
      ),
    
 
  });

  // Function to sanitize input by removing unwanted characters
  const sanitizeInput = (value: string, fieldName: string) => {
    if (!value) return value;
    
    let sanitized = value;
    
    switch(fieldName) {
      case 'name':
        // Allow only letters, numbers, spaces, hyphens, and common punctuation
        sanitized = value.replace(/[^a-zA-Z0-9\s\-&.,()]/g, '');
        // Remove multiple consecutive special characters
        sanitized = sanitized.replace(/([\-\s&.,()]){2,}/g, '$1');
        // Trim special characters from start and end
        sanitized = sanitized.replace(/^[^a-zA-Z0-9\s]+|[^a-zA-Z0-9\s]+$/g, '');
        break;
     
      default:
        // Default sanitization for other fields
        sanitized = value.replace(/[<>{}[\]\\]/g, '');
    }
    
    return sanitized;
  };

  // Custom onChange handler to sanitize input in real-time
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value, name);
    
    // Only update if the value changed after sanitization
    if (value !== sanitizedValue) {
      formik.setFieldValue(name, sanitizedValue);
    } else {
      formik.handleChange(e);
    }
  };

  const formik = useFormik({
    initialValues: {
      id: -1,
      name: "",
    nodeID: -1,

     titleID: 0

    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Additional server-side validation before submission
      const sanitizedValues = {
        ...values,
        name: sanitizeInput(values.name, 'name'),
     
      };
      
      // Clear any existing timeout
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
      
      // If already submitting, show message and return
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }
      
      setIsSubmitting(true);
      
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL + `NewNodeMaster/AddUpdateNewNodeMaster`,
          sanitizedValues
        );
        
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate('/master/DepartmentMaster');
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        // Set a timeout to reset isSubmitting after 2 seconds
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    }
  });

  // Clean up timeout on component unmount
  useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh"
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "16px", fontWeight: 500, marginLeft: "30px" }}
          >
            {t("text.createdeptmaster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={6} xs={12}>
                <TextField
                  id="name"
                  name="name"
                  label={
                    <span>
                      {t("text.enterdeptName")}{" "}
                      {requiredFields.includes('name') && (
                        <span style={{ color: formik.values.name ? 'green' : 'red' }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.name}
                  placeholder={t("text.enterdeptName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: 'white',
                    borderColor: formik.touched.name && formik.errors.name ? 'red' : 'initial',
                  }}
                  onChange={handleInputChange}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ 
                    maxLength: 50,
                    pattern: "[a-zA-Z0-9\\s\\-&.,()]*"
                  }}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.name)}</div>
                ) : null}
              </Grid>
<Grid item lg={6} xs={12}>
  </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={isSubmitting || !formik.isValid}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.save")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    formik.resetForm();
                  }}
                  disabled={isSubmitting}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default DepartmentAdd;